import Card from 'common/components/Card/Card';
import FormInput from 'common/components/FormInput/FormInput';
import FormScrollError from 'common/components/FormScrollError/FormScrollError';
import useAuth from 'common/contexts/auth';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import CompanySelect from 'requests/components/CompanySelect';
import useCompanies from 'requests/contexts/companies';

const JobForm = ({ onSubmit, job }) => {
  const { t } = useTranslation();
  const { user: currentUser } = useAuth();
  const { currentCompany } = useCompanies();

  const initialValues = useMemo(() => job?.id ? ({
    ...job,
    company: job?.company.id,
  }) : ({
    name: job?.name,
    company: currentCompany.id,
  }), [job, currentCompany]);

  return (
    <Form
      onSubmit={onSubmit}
      subscription={{ values: true, submitting: true, pristine: true }}
      initialValues={initialValues}
      render={({
        handleSubmit, submitting, pristine,
      }) => (
        <form onSubmit={handleSubmit} noValidate>
          <FormScrollError />
          <div className="columns">
            <div className="column">
              <Card>
                { !currentCompany && currentUser?.role?.name === 'superadmin' && (
                <FormInput
                  type="custom"
                  name="company"
                  label={t('common.company')}
                >
                  <CompanySelect />
                </FormInput>
                )}
                <FormInput
                  name="name"
                  label={t('common.name')}
                  required
                />
                <FormInput
                  type="submit"
                  label={t('common.send')}
                  icon="paper-plane"
                  disabled={submitting || pristine}
                  isSubmitting={submitting}
                />
              </Card>
            </div>
          </div>

        </form>
      )}
    />
  );
};

JobForm.propTypes = {
  onSubmit: PropTypes.func,
  job: PropTypes.object,
};

JobForm.defaultProps = {
  onSubmit() {},
  job: {},
};

export default JobForm;
